import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import app from './App';
// Replaces the MUI CssBaseline that UnifiedThemeProvider dropped in Backstage
// 1.44. Without it, the browser's default body margin sits under every plugin
// page (height: 100vh) while the sidebar stays pinned to the viewport.
import '@backstage/ui/css/styles.css';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(app);
